import { IMyTicket } from '../ticketshop/types';

/**
 * Whether the "Ticket als Chipkarte erhalten" entry is offered for a ticket.
 *
 * Trusts the BE-provided `eligibilityForChipcard` flag (detail endpoint). The
 * backend owns the decision — which operator, billing mode and ticket class
 * qualify — so the frontend no longer re-derives it from `operatorName` /
 * `billingMode` (MC-11409). Absent flag (e.g. the list model) is not eligible.
 *
 * The request is emailed to the operator's `chipcardContact.email`, so without
 * that address there is nowhere to send it — the option is hidden and the
 * chipcard request screen is not reachable either (MC-12044).
 */
export const isChipcardEligible = (ticket: IMyTicket): boolean =>
	ticket.eligibilityForChipcard === true &&
	!!ticket.chipcardContact?.email?.trim();
